// extracted by mini-css-extract-plugin
export default {"checkbox":"river-checkbox-formatter_checkbox__qsl+U","mobile":"river-checkbox-formatter_mobile__RbwWu"};